const JAKARTA_TIME_ZONE = 'Asia/Jakarta';

function getJakartaDateParts(date = new Date()) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: JAKARTA_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const parts = formatter.formatToParts(date);
  return parts.reduce((result, part) => {
    if (part.type !== 'literal') result[part.type] = part.value;
    return result;
  }, {});
}

export function formatJakartaDateInput(date = new Date()) {
  const { year, month, day } = getJakartaDateParts(date);
  return `${year}-${month}-${day}`;
}

export function getJakartaCurrentMonthRange(date = new Date()) {
  const { year, month } = getJakartaDateParts(date);
  const lastDay = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
  return {
    startDate: `${year}-${month}-01`,
    endDate: `${year}-${month}-${String(lastDay).padStart(2, '0')}`,
  };
}

export function isInspectionInJakartaDateRange(createdAt, startDate, endDate) {
  if (!createdAt) return true;
  const parsed = new Date(createdAt);
  if (Number.isNaN(parsed.getTime())) return false;
  const businessDate = formatJakartaDateInput(parsed);
  if (startDate && businessDate < startDate) return false;
  if (endDate && businessDate > endDate) return false;
  return true;
}

function getScopeKey(inspection) {
  if (inspection?.unitId !== undefined && inspection?.unitId !== null) {
    return `unit:${inspection.unitId}`;
  }
  const deviceId = String(inspection?.deviceId || inspection?.unit?.deviceId || '').trim().toLowerCase();
  return deviceId ? `device:${deviceId}` : `inspection:${inspection?.id}`;
}

export function applyInspectionView(inspections = [], viewMode = 'monthly_latest') {
  if (viewMode === 'history') return [...inspections];

  const selected = new Map();
  [...inspections]
    .sort((left, right) => {
      const timeDiff = new Date(right.createdAt || 0).getTime() - new Date(left.createdAt || 0).getTime();
      return timeDiff || Number(right.id || 0) - Number(left.id || 0);
    })
    .forEach((inspection) => {
      const key = getScopeKey(inspection);
      if (!selected.has(key)) selected.set(key, inspection);
    });
  return Array.from(selected.values());
}

export { JAKARTA_TIME_ZONE };
